'use client'; // Error components must be Client components

import ErrorPage from '@/components/errors/ErrorPage/ErrorPage';
import CommonFooter from '@/components/layouts/CommonFooter/CommonFooter';
import CommonHeader from '@/components/layouts/CommonHeader/CommonHeader';
import CommonHeaderSp from '@/components/layouts/CommonHeaderSp/CommonHeaderSp';
import CommonMenu from '@/components/layouts/CommonMenu/CommonMenu';
import { PRODUCT_NAME } from '@/constants';
import '@/styles/global.scss';
import layoutStyles from '@/styles/modules/layout.module.scss';
import utilsStyles from '@/styles/modules/utils.module.scss';
import '@/styles/reset.scss';
import ActionButton from '@/components/form/ActionButton/ActionButton';
import * as Sentry from '@sentry/nextjs';

// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
export default function Error({ error }: { error: Error }) {
  if (error) {
    Sentry.captureException(error);
    Sentry.flush(2000);
  }

  return (
    <>
      <div className={utilsStyles.onlySp}>
        <CommonHeaderSp navButtonDispFlg={false} />
        <CommonMenu />
      </div>
      <div className={utilsStyles.onlyPc}>
        <CommonHeader navButtonDispFlg={false} />
      </div>
      <div className={`${layoutStyles.pageWrapper}`}>
        <div className={layoutStyles.page}>
          <main>
            <div className={layoutStyles.pageContainer}>
              <div className={utilsStyles.mtSmall}>
                <ErrorPage
                  statusCode={500}
                  name={'SERVER ERROR'}
                  description={'エラーが発生しました。お時間をあけて再度アクセスをお願い致します。'}
                />
              </div>
              <div className={`${utilsStyles.mtMedium} ${utilsStyles.fullWidth} ${utilsStyles.centered}`}>
                <ActionButton href='/' size='large' bgColor='red' color='white'>
                  トップページへ
                </ActionButton>
              </div>
            </div>
          </main>
        </div>
      </div>
      <CommonFooter siteName={PRODUCT_NAME} />
    </>
  );
}
